import { render } from "./MultisidebarGroup.vue?vue&type=template&id=712a2327&ts=true"
import script from "./MultisidebarGroup.vue?vue&type=script&lang=ts"
export * from "./MultisidebarGroup.vue?vue&type=script&lang=ts"

import "./MultisidebarGroup.vue?vue&type=style&index=0&id=712a2327&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__